import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Entrega',
    pickup: 'Recogida',
  },
  asap: 'Cuanto antes',
  unavailable: 'No disponible',
  ready_in_time: 'Listo en {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Entrega en {{address}}',
    [ORDER_METHODS.PICKUP]: 'Recogida en {{address}}',
  },
  buttons: {
    change: 'Cambiar',
    see_hours: 'Ver horario',
    change_location: 'Cambiar ubicación',
    change_time: 'Cambiar hora',
  },
};
